import { render, staticRenderFns } from "./OfficeFloatBtns.vue?vue&type=template&id=5c56123c&"
import script from "./OfficeFloatBtns.vue?vue&type=script&lang=js&"
export * from "./OfficeFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports